import { ExercisePayload } from '_api/types';

const DefaultNewExercise: ExercisePayload = {
  title: '',
  description: '',
  imageUrl: '',
  targetSide: '',
  equipment: [],
  category: [],
  notes: '',
  instructionList: [],
  videoLink: '',
  shareWithOrg: false,
};

export default DefaultNewExercise;
